
import axios from 'axios'
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import { Tooltip } from 'bootstrap/dist/js/bootstrap.esm.min.js';
import { VueRecaptcha } from 'vue-recaptcha';

export default {
    components: {
         VueRecaptcha
    },
     mounted() {

        (() => {
            'use strict'

            // Fetch all the forms we want to apply custom Bootstrap validation styles to
            const forms = document.querySelectorAll('.needs-validation')

            // Loop over them and prevent submission
            Array.from(forms).forEach(form => {
                form.addEventListener('submit', event => {
                    if (!form.checkValidity()) {
                        event.preventDefault()
                        event.stopPropagation()
                    }

                    form.classList.add('was-validated')
                }, false)
            })
        })()
        this.$store.commit('setTextoHeader', 1)
        Array.from(document.querySelectorAll('button[data-bs-toggle="tooltip"]'))
            .forEach(tooltipNode => new Tooltip(tooltipNode))
        Array.from(document.querySelectorAll('a[data-bs-toggle="tooltip"]'))
            .forEach(tooltipNode => new Tooltip(tooltipNode))
        Array.from(document.querySelectorAll('img[data-bs-toggle="tooltip"]'))
            .forEach(tooltipNode => new Tooltip(tooltipNode))


    },

    data() {
        return {
            TipoDocumento: "",
            Identificacion: "",
            FechaDocumento: "",
            nombreUsuario: "",
            titulo: "Cargando",
            modalBody: "Espere un momento mientras se valida la información",
            entrar: "",
            txtBoton: "Continuar",
            estatus: "",
            id: "",
            loading: true,
            recaptcha: null,
        }
    },
    setup() {
    },

    methods: {
        async login() {

            //Obtener fecha de documento ingresado

            let dia = this.FechaDocumento.getDate()
            let mes = this.FechaDocumento.getMonth() + 1
            let anio = this.FechaDocumento.getFullYear()
            dia = ('0' + dia).slice(-2)
            mes = ('0' + mes).slice(-2)
            let fechaConvert = `${anio}-${mes}-${dia}`


            //Obtener fecha actual

            let date = new Date();
            let day = date.getDate();
            day < 10 ? day = ('0' + day) : day;
            let month = date.getMonth() + 1;
            month < 10 ? month = ('0' + month) : month;
            let year = date.getFullYear();
            let fecha = `${year}-${month}-${day}`;


            this.$store.commit('setFechaInicio', fecha);


            //Validar datos de usuario para login

            let json = {
                FechaDocumento: fechaConvert,
                Identificacion: this.Identificacion,
                TipoDocumento: this.TipoDocumento,
            };
            const obetenerUsuario = async () => {
                try {
                    const respuesta = await axios.post('https://ansv-func-licencias-qa-apim.azure-api.net/ANSV-func-licencias-qa-aspirante/aspirante', json)
                    this.estatus = respuesta.status

                    if (respuesta.status === 200) {
                        this.Cargando();
                        this.id = respuesta.data.idAspirante
                        this.nombreUsuario = respuesta.data.nombre + " " + respuesta.data.primeroApellido + " " + respuesta.data.segundoApellido
                        this.$store.commit('setIdUsuario', respuesta.data.idAspirante);
                        this.$store.commit('setIdExamenSesion', respuesta.data.idExamenSesion)
                        this.$store.commit('setNameUsuario', respuesta.data.nombre);
                        this.$store.commit('setPrimerApellidoUsuario', respuesta.data.primerApellido);
                        this.$store.commit('setCategoriaLicecia', respuesta.data.examenSolicitud[0].categoriaLicencia);
                        this.$store.commit('setAutentication', true)
                        // this.$store.commit('setCorreoUsuario', respuesta.data.correo);
                        this.txtBoton = "Ingresar"
                        this.entrar = "/bienvenida-prueba-tecnica"

                        //alert('Datos correctos');
                        this.titulo = "Usuario correcto"
                        this.modalBody = "La combinación de documento de identificación y número es correcta, por favor ingrese a la prueba."

                    }
                } catch (error) {
                    this.titulo = "Usuario incorrecto"
                    this.modalBody = "Los datos ingresados no coinciden con los datos de ningún aspirante registrado en la plataforma de la ANSV"
                }
            };
            obetenerUsuario()
        },


        //Seleccionar fecha de documento 

        selector() {
            const selected = document.querySelector(".selected");
            const optionsContainer = document.querySelector(".options-container");

            const optionsList = document.querySelectorAll(".option");

            optionsContainer.classList.toggle("active");


            optionsList.forEach(o => {
                o.addEventListener("click", () => {
                    selected.innerHTML = o.querySelector("label").innerHTML;
                    optionsContainer.classList.remove("active");
                });
            });
        },

        //Información para modal 

        Cargando() {
            this.titulo = "Cargando..."
            this.modalBody = "Validando la información del usuario."
        },
        

        //Validación de captcha

         async onCaptchaVerified(respon) {
            let json = {
                "secret": "6Le5GH0jAAAAAH9Sc2PLP-D-TQLk6CZqUY3_P4Yt",
                "response" : respon,
            }
            let body = JSON.stringify(json)
            try {
                const respuesta =  await axios.post( 'https://ansv-func-licencias-qa-apim.azure-api.net/ANSV-func-licencias-qa-validacion-captcha/validacion-captcha',body)
                console.log(respuesta.data);
                if(respuesta.data === true) {
                    this.loading = false;
                }else{
                    console.log("error en validación")
                }
     
            } catch (error) {
                console.log(error);
            }
        },
    
    },
}


